import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import { BrowserRouter as Router } from "react-router-dom";
import SnackbarProvider from "react-simple-snackbar"

import App from './App';

ReactDOM.render(
	<React.StrictMode>
		<Router>
			<SnackbarProvider>
				<App />
			</SnackbarProvider>
		</Router>
	</React.StrictMode>,
	document.getElementById('root')
);